<template>
  <van-nav-bar :border="false" fixed>
    <template #left><van-icon :style="colorStyle" @click="goBack" name="arrow-left back-icon"/></template>
    <template #title>
      <div :style="colorStyle" class="nav-title">
        {{ title }}
      </div>
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  props: {
    title: String,
    textColor: {
      type: String,
      default: ""
    },
    backPage: String,
    backFn: Function
  },
  methods: {
    goBack() {
      if (this.backFn) {
        this.backFn();
      } else if (this.backPage) {
        this.$router.replace({ name: this.backPage });
      } else {
        this.$router.back();
      }
    }
  },
  computed: {
    colorStyle() {
      if (this.textColor) {
        return { color: `${this.textColor} !important` };
      }
      return {};
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-title {
  font-size: $fs-main;
  color: $fc-black;
}

.back-icon {
  font-size: $fs-l !important;
  color: $fc-black !important;
}
</style>
